import type { Agent } from '@fingerprintjs/fingerprintjs'

let fpPromise: Promise<Agent> | null = null

// Computing the fingerprint takes 60–170 ms of the main thread (canvas, WebGL, fonts).
// Started from onMounted it landed inside the hydration task and delayed the first
// response to input (#296), so it waits until the browser is idle.
const whenIdle = () =>
  new Promise<void>((resolve) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => resolve(), { timeout: 3000 })
    } else {
      // Safari has no requestIdleCallback; a second is enough for the hydration to finish
      setTimeout(resolve, 1000)
    }
  })

export function useFingerprintJS() {
  const getVisitorId = async (): Promise<string> => {
    if (!fpPromise) {
      await whenIdle()
      fpPromise ??= import('@fingerprintjs/fingerprintjs').then((m) => m.default.load())
    }

    const fp = await fpPromise
    await whenIdle()
    const result = await fp.get()
    return result.visitorId
  }

  return {
    getVisitorId
  }
}
